







































































import { Component, Vue, Prop, Provide, Watch, Emit } from 'vue-property-decorator'
import { NetsTab, Ranger, NoResult } from '@/components'
import PreviewBtn from './PreviewBtn.vue'
import QuestionBox from './QuestionBox.vue'
import { isObjectValueEqual, getUrlParams } from '@/utils/urlUtils'
import { sa } from '@/utils/sa'

import {
  questionList,
  addQuestionToCart,
  removeUestionFromCart,
  updateQuestionCart
} from './../model/api'
@Component({
  components: { NetsTab, Ranger, PreviewBtn, QuestionBox, NoResult }
})
export default class QuestionList extends Vue {
  @Prop() public isUnion!: string

  public currentTitle = ''
  public data: any = []
  public loading = false
  // pagination-data
  public page = 1
  public total = 0
  public sum = 0
  public perPage = 5
  public sortWay: number | string = 1
  public hasAnalysis = false
  public blackList = ['103']
  private currentSite = this.nets[0] // 初始值
  // computed
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get nets() {
    if (this.userInfo && this.userInfo.is_oto_account) {
      if (/^1\d{2}$/.test(this.subject.value)) {
        return [[8, '小学OTO'], [1, '17题库']]
      }
      return [[1, '17题库']]
    } else {
      return [[1, '17题库']]
    }
  }
  private get subject() {
    return this.$store.state.subject
  }
  private get cartInfo() {
    return this.$store.state.question.cart
  }
  private get year() {
    return this.$store.state.question.year
  }
  private get diff() {
    return this.$store.state.question.diff
  }
  private get questionType() {
    return this.$store.state.question.questiontype
  }
  private get region() {
    return this.$store.state.question.region
  }
  private get filters() {
    return {
      year: this.year,
      diff: this.diff,
      questionType: this.questionType,
      region: this.region,

      grade: this.$store.state.question.grade,
      textbookVersion: this.$store.state.question.textbookVersion,
      paperType: this.$store.state.question.paperType
    }
  }
  private get factors() {
    return this.$store.state.question.factors
  }
  private get kps() {
    return this.$store.state.question.kps || []
  }
  private get catalog() {
    return this.$store.state.question.catalog
  }
  private get user() {
    return this.$store.state.user
  }
  private get bookorkps() {
    return this.$store.state.question.bookorkps
  }
  private get singleormulti() {
    return this.$store.state.question.singleormulti
  }
  private get book() {
    return this.$store.state.question.book
  }
  private get diffName() {
    return this.$store.state.question.diffname
  }
  private get provinceName() {
    return this.$store.state.question.provincename
  }
  private get questiontypeName() {
    return this.$store.state.question.questiontypename
  }
  private get showTitle() {
    return this.userInfo ? this.userInfo.is_inner_user : ''
  }

  //
  private get paperType() {
    return this.$store.state.question.paperType
  }
  private get grade() {
    return this.$store.state.question.grade
  }
  private get textbookVersion() {
    return this.$store.state.question.textbookVersion
  }

  @Watch('hasAnalysis')
  onHasAnalysisChange(val, old) {
    this.page = 1
    this.loadQuestions(this.page)
  }

  @Watch('userInfo', { deep: true })
  onUserChange(val, old) {
    if (!val) return
    if (old && val.username === old.username) return
    // console.log(val)
    if (val.is_oto_account) {
      this.currentSite = [8, '小学OTO']
      this.siteChange(this.currentSite)
    }
    this.page = 1
    this.loadQuestions(this.page)
    // location.reload()
  }
  @Watch('book')
  onBookChange(val, old) {
    if (~~this.bookorkps === 2) return
    if (val === old) return
    this.page = 1
    this.loadQuestions(this.page)
    console.log(9)
  }
  @Watch('singleormulti')
  onSwitchChange(val, old) {
    if (val === old) return
    this.page = 1
    this.loadQuestions(this.page)
    console.log(8)
  }
  @Watch('bookorkps')
  onStatusChange(val, old) {
    if (val === old) return
    this.page = 1
    this.loadQuestions(this.page)
    console.log(7)
  }
  @Watch('subject', { deep: true })
  onSubjectChange(val, old) {
    if (val.value === old.value) return
    this.page = 1
    this.currentTitle = ''
    this.currentSite = this.nets[0]
    this.siteChange(this.currentSite)
  }
  @Watch('factors')
  onFactorsChange(val) {
    if (~~this.bookorkps === 1) return
    this.page = 1
    console.log(1)
    this.loadQuestions(this.page)
  }
  @Watch('kps')
  onKpsChange(val) {
    if (~~this.bookorkps === 1) return
    this.page = 1
    console.log(2)
    this.loadQuestions(this.page)
  }
  @Watch('catalog')
  onCataChange(val) {
    this.page = 1
    console.log(3)
    this.loadQuestions(this.page)
  }
  @Watch('filters', { deep: true })
  onFiltersChange(val) {
    this.page = 1
    this.loadQuestions(this.page)
    console.log(5)
    //
    this.collectInfo()
  }
  @Watch('currentTitle')
  onCurrentTitleChange(val) {
    if (val === '') {
      this.page = 1
      this.loadQuestions(this.page)
      console.log(6)
    }
  }
  @Watch('cartInfo', { deep: true })
  onCartChange(val, old) {
    if (isObjectValueEqual(val, old)) {
      return
    }
    // console.log(this.diff)
    // this.loadQuestions(this.page)
    this.onFlagChange(this.cartInfo, this.data)

    // console.log(7)
  }
  // 监听点击知识点交集、 并集
  @Watch('isUnion')
  onIsUnionChange(val) {
    this.page = 1
    this.loadQuestions(this.page)
  }
  @Emit()
  public siteChange(val) {
    return val
  }
  // mounted
  public mounted() {
    // this.loadQuestions(this.page)
    // console.log(8)
    // console.log(this.cartInfo)
    // this.onFlagChange(this.cartInfo)
    this.siteChange(this.currentSite)
  }

  public onFilterHasAnalysis(e) {
    console.log('onFilterHasAnalysis val = ' + e.target.checked)
    this.hasAnalysis = e.target.checked
  }

  public onTabSelect(val) {
    // console.log(val)
    this.currentSite = val
    this.siteChange(val) // emit-out
    this.page = 1
    this.loadQuestions(this.page)
  }
  public reset() {
    location.href = '/search'
  }
  public judgeCode(data) {}
  /**
   * onSearch
   */
  public onSearch() {
    this.page = 1
    this.loadQuestions(this.page)
    // console.log(9)
  }
  public openAnalysis(item) {
    item.showAnalysis = !item.showAnalysis
    setTimeout(() => {
      sa.track('ContentRepository_question_Other', {
        screenType: '题目页面',
        buttonName: '显示解析'
      })
    }, 50)
  }
  public clickRanger(status) {
    switch (status) {
      case 'down':
        this.sortWay = 1
        break
      case 'up':
        this.sortWay = 0
        break
      default:
        break
    }
    this.page = 1
    this.loadQuestions(this.page)
    //
    this.collectInfo()
  }

  public async chooseAll() {
    if (!this.user || !this.user.name) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    //
    setTimeout(() => {
      sa.track('ContentRepository_question_Other', {
        screenType: '题目页面',
        buttonName: '本页全选'
      })
    }, 50)
    let arr = [...this.cartInfo.question_ids]
    let temp: any = []
    let params: any = {
      question_cart: {
        question_ids: []
      },
      subject_id: this.subject.value
    }
    for (let n of this.data) {
      temp = [...temp, n.id]
    }
    params.question_cart.question_ids = [...new Set([...arr, ...temp])]
    let data = await updateQuestionCart(params)
    if (data.success) {
      this.$store.commit('SET_CART', data.msg)
    } else {
      this.$message.warning(data.error)
    }
  }
  public onFlagChange(data, data2) {
    let dataCopy = JSON.parse(JSON.stringify(data2))
    for (let n of dataCopy) {
      if (!data) {
        return
      }
      if (data.question_ids.findIndex((item) => (n as any).id === item) > -1) {
        n.inShoppingCart = true
      } else {
        n.inShoppingCart = false
      }
      if (n.showAnalysis) {
        n.showAnalysis = true
      } else {
        n.showAnalysis = false
      }
    }
    this.data = dataCopy
  }
  public useKps() {
    if (~~this.bookorkps === 2) {
      this.factors &&
      this.factors.checked &&
      this.factors.checked.length > 0 &&
      this.singleormulti === '2'
        ? this.processFactors(this.factors.checked)
        : this.processFactors(this.kps)
    } else {
      return this.catalog || ''
    }
  }
  public async loadQuestions(page: number | string, cata?) {
    let params: any = {
      subject_id: this.subject.value,
      page: page,
      keyword: this.currentTitle,
      sort_way: this.sortWay,
      year: this.year,
      difficulty: this.diff,
      question_type: this.questionType,
      region_code: this.region,
      book_catalog_id: '',
      knowledge_point_ids: [],
      source: undefined,
      kp_search_type: undefined,
      has_analysis: this.hasAnalysis || false // 是否解析only
    }

    if (this.currentSite && this.currentSite[0] === 8) {
      params.source = [this.currentSite[0]]
    } else {
      params.source = [1, 2, 3]
    }

    if (~~this.bookorkps === 2) {
      params.book_catalog_id = ''
      if (~~this.singleormulti === 2) {
        params.knowledge_point_ids = this.processFactors(this.factors.checked)
        params.kp_search_type = ~~this.isUnion || 1
      } else {
        params.knowledge_point_ids = this.processFactors(this.kps)
      }
    } else {
      params.knowledge_point_ids = []
      if (this.catalog && !cata) {
        params.book_catalog_id = this.catalog
      } else {
        params.book_catalog_id = this.book
      }
    }

    if (~~this.bookorkps === 2) {
      // 知识点
      params.book_catalog_id = this.textbookVersion
      params.grade_term = this.grade
      params.paper_type = this.paperType
    } else {
      // 章节
      params.grade_term = undefined
      params.paper_type = undefined
    }

    let data = await questionList(params)
    if (data.success) {
      // this.data = data.questions
      this.total = data.data.total_count
      this.sum = data.data.page_count * this.perPage
      this.onFlagChange(this.cartInfo, data.data.questions)
    } else {
      this.total = 0
      this.sum = 0
      this.data = []
      // this.judgeCode(data)
    }
  }
  /**
   * clearSearchInput
   */
  public clearSearchInput() {
    this.currentTitle = ''
  }
  public onPageChange(val) {
    this.page = val
    this.loadQuestions(val)
    // console.log(10)
    if (this.currentTitle) {
      setTimeout(() => {
        sa.track('ContentRepository_Paging', {
          screenType: '题目页面',
          fiterPaging: '搜索翻页',
          pageNumber: this.page
        })
      }, 50)
    } else {
      setTimeout(() => {
        sa.track('ContentRepository_Paging', {
          screenType: '题目页面',
          fiterPaging: '筛选翻页',
          pageNumber: this.page
        })
      }, 50)
    }
  }
  public async cartAdd(id: number | string) {
    let data = await addQuestionToCart({
      question_id: id,
      subject_id: this.subject.value
    })
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.msg)
      this.onFlagChange(this.cartInfo, this.data)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }
  }
  public async cartDelete(id: number | string) {
    let data = await removeUestionFromCart({
      question_id: id,
      subject_id: this.subject.value
    })
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.msg)
      this.onFlagChange(this.cartInfo, this.data)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }
  }
  public addToCart(data) {
    if (data.val) {
      this.cartAdd(data.id)
      setTimeout(() => {
        sa.track('ContentRepository_question_Other', {
          screenType: '题目页面',
          buttonName: '加入试题篮'
        })
      }, 50)
    } else {
      this.cartDelete(data.id)
      setTimeout(() => {
        sa.track('ContentRepository_question_Other', {
          screenType: '题目页面',
          buttonName: '移出试题篮'
        })
      }, 50)
    }
  }
  public processFactors(val) {
    let temp: any = []
    if (val && val.length) {
      for (let n of val) {
        temp = [...temp, n.split('?')[0]]
      }
    }
    return temp
  }

  public collectInfo() {
    setTimeout(() => {
      sa.track('ContentRepository_Filter', {
        screenType: '题目页面',
        modules: '手工组卷',
        QuestionTypes: this.questiontypeName,
        difficulty: this.diff,
        difficulty_name: this.diffName,
        year: this.year + '',
        province: this.region,
        province_name: this.provinceName,
        timeSequence: this.sortWay === 0 ? '升序' : '降序'
      })
    }, 50)
  }
}
